import HttpResponse from "../../../../utils/http/http.response";

type CandidatureAddByOrderIdSuccessResponse = HttpResponse<string>;

export enum CandidatureAddByOrderIdNotAcceptableResponseErrorType {
  DRIVER_HAS_CANDIDATURE = "DRIVER_HAS_CANDIDATURE",
  NO_TAXI_DRIVER_ASSOCIATION = "NO_TAXI_DRIVER_ASSOCIATION",
  NO_VALID_TAXI_DRIVER_CONTRACT = "NO_VALID_TAXI_DRIVER_CONTRACT",
  NO_VALID_TAXI_RAILY_CONTRACT = "NO_VALID_TAXI_RAILY_CONTRACT",
  NO_VALID_CARGO_RAILY_CONTRACT = "NO_VALID_CARGO_RAILY_CONTRACT",
  TARGET_PLAN_ENTRY_NOT_FOUND = "TARGET_PLAN_ENTRY_NOT_FOUND",
  CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME = "CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME",
  CANDIDATE_DOES_NOT_FIT = "CANDIDATE_DOES_NOT_FIT",
  TOO_MANY_CHECKOUT_EVENTS = "TOO_MANY_CHECKOUT_EVENTS",
  CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION = "CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION",
  DELETE_SOLVED_ORDER_TARGET_NOT_FOUND = "DELETE_SOLVED_ORDER_TARGET_NOT_FOUND",
  PLAN_ENTRY_CANDIDATE_COLLISION = "PLAN_ENTRY_CANDIDATE_COLLISION",
  FORBIDDEN_TAXI = "FORBIDDEN_TAXI",
  FORBIDDEN_PLAN_ENTRY = "FORBIDDEN_PLAN_ENTRY",
  PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR = "PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR",
  SOLVED_ORDER_CANDIDATE_START_TIME_EXPIRED_ERROR = "SOLVED_ORDER_CANDIDATE_START_TIME_EXPIRED_ERROR",
}

export enum CollisionSubjectDirectionResponse {
  PREVIOUS = "PREVIOUS",
  NEXT = "NEXT",
}

export type CandidatureAddByOrderIdNotAcceptableResponseErrorCollisionInfo = {
  requiredGap: number;
  existingGap: number;
};

export type CandidatureAddByOrderIdNotAcceptableResponseErrorCollisionSubject =
  {
    collisionDirection: CollisionSubjectDirectionResponse;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseDriverHasCandidatureError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.DRIVER_HAS_CANDIDATURE;
    driverId: string;
    taxiId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseNoTaxiDriverAssociationError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.NO_TAXI_DRIVER_ASSOCIATION;
    driverId: string;
    taxiId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseNoValidTaxiDriverContractError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.NO_VALID_TAXI_DRIVER_CONTRACT;
    driverId: string;
    taxiId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseNoValidTaxiRailyContractError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.NO_VALID_TAXI_RAILY_CONTRACT;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseNoValidCargoRailyContractError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.NO_VALID_CARGO_RAILY_CONTRACT;
    driverId: string;
    taxiId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseTargetPlanEntryNotFoundError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.TARGET_PLAN_ENTRY_NOT_FOUND;
    candidateEntryId: string;
    targetPlanEntryId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseCandidateFitsWithNotEnoughTimeError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_NOT_ENOUGH_TIME;
    candidatureId: string;
    candidatureEntryId: string;
    collidingSolvedOrderId: string;
    candidatureSolvedOrderId: string;
    collisionInfo: CandidatureAddByOrderIdNotAcceptableResponseErrorCollisionInfo;
    collisionSubject: CandidatureAddByOrderIdNotAcceptableResponseErrorCollisionSubject;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseTooManyCheckoutEventsError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.TOO_MANY_CHECKOUT_EVENTS;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseCandidateDoesNotFitError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.CANDIDATE_DOES_NOT_FIT;
    candidatureId: string;
    candidatureEntryId: string;
    collidingSolvedOrderId: string;
    candidatureSolvedOrderId: string;
    collisionInfo: CandidatureAddByOrderIdNotAcceptableResponseErrorCollisionInfo;
    collisionSubject: CandidatureAddByOrderIdNotAcceptableResponseErrorCollisionSubject;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseCandidatePlanEntryCollidesError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.CANDIDATE_FITS_WITH_PLAN_ENTRY_COLLISION;
    candidatureId: string;
    candidatureEntryId: string;
    candidaturePlanEntryId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseDeleteSolvedOrderTargetNotFoundError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.DELETE_SOLVED_ORDER_TARGET_NOT_FOUND;
    candidatureId: string;
    candidateEntryId: string;
    targetSolvedOrderId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponsePlanEntryCandidateCollisionError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.PLAN_ENTRY_CANDIDATE_COLLISION;
    candidatureId: string;
    candidateEntryId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseForbiddenTaxiError = {
  errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.FORBIDDEN_TAXI;
  providedTaxiId: string;
};

export type CandidatureAddByOrderIdNotAcceptableResponseForbiddenPlanEntryError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.FORBIDDEN_PLAN_ENTRY;
    providedPlanEntryId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponsePlanEntryCandidateStartTimeExpiredError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.PLAN_ENTRY_CANDIDATE_START_TIME_EXPIRED_ERROR;
    candidatureId: string;
    candidatureEntryId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseSolvedOrderCandidateStartTimeExpiredError =
  {
    errorType: CandidatureAddByOrderIdNotAcceptableResponseErrorType.SOLVED_ORDER_CANDIDATE_START_TIME_EXPIRED_ERROR;
    solvedOrderId: string;
  };

export type CandidatureAddByOrderIdNotAcceptableResponseError =
  | CandidatureAddByOrderIdNotAcceptableResponseDriverHasCandidatureError
  | CandidatureAddByOrderIdNotAcceptableResponseNoTaxiDriverAssociationError
  | CandidatureAddByOrderIdNotAcceptableResponseNoValidTaxiDriverContractError
  | CandidatureAddByOrderIdNotAcceptableResponseNoValidTaxiRailyContractError
  | CandidatureAddByOrderIdNotAcceptableResponseNoValidCargoRailyContractError
  | CandidatureAddByOrderIdNotAcceptableResponseTargetPlanEntryNotFoundError
  | CandidatureAddByOrderIdNotAcceptableResponseCandidateFitsWithNotEnoughTimeError
  | CandidatureAddByOrderIdNotAcceptableResponseCandidateDoesNotFitError
  | CandidatureAddByOrderIdNotAcceptableResponseCandidatePlanEntryCollidesError
  | CandidatureAddByOrderIdNotAcceptableResponseDeleteSolvedOrderTargetNotFoundError
  | CandidatureAddByOrderIdNotAcceptableResponsePlanEntryCandidateCollisionError
  | CandidatureAddByOrderIdNotAcceptableResponseForbiddenTaxiError
  | CandidatureAddByOrderIdNotAcceptableResponseForbiddenPlanEntryError
  | CandidatureAddByOrderIdNotAcceptableResponseTooManyCheckoutEventsError
  | CandidatureAddByOrderIdNotAcceptableResponsePlanEntryCandidateStartTimeExpiredError
  | CandidatureAddByOrderIdNotAcceptableResponseSolvedOrderCandidateStartTimeExpiredError;

export type CandidatureAddByOrderIdNotAcceptableResponse =
  HttpResponse<CandidatureAddByOrderIdNotAcceptableResponseError>;

type CandidatureAddByOrderIdResponse =
  | CandidatureAddByOrderIdSuccessResponse
  | CandidatureAddByOrderIdNotAcceptableResponse;

export default CandidatureAddByOrderIdResponse;
